import { z } from 'zod';

import { InstanceIdType } from '#schema/defs';

export const CogniteSchedulableModel = z.object({
  ...InstanceIdType.shape,

  startTime: z.coerce.date().optional().describe('The actual start time of an activity (or similar that extends this)'),
  endTime: z.coerce.date().optional().describe('The actual end time of an activity (or similar that extends this)'),
  scheduledStartTime: z.coerce
    .date()
    .optional()
    .describe('The planned start time of an activity (or similar that extends this)'),
  scheduledEndTime: z.coerce
    .date()
    .optional()
    .describe('The planned end time of an activity (or similar that extends this)'),
});

export type CogniteSchedulableModelInput = z.input<typeof CogniteSchedulableModel>;
export type CogniteSchedulableModelOutput = z.output<typeof CogniteSchedulableModel>;
